import { render, staticRenderFns } from "./BoningExport.vue?vue&type=template&id=16a016fa"
import script from "./BoningExport.vue?vue&type=script&setup=true&lang=js"
export * from "./BoningExport.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports